<p-overlayPanel
    #op
    [style]="{ 'min-width': '200px', padding: '-20px', margin: '-20px' }"
>
    <ng-template pTemplate>
        <div class="conn-grid" style="margin-top: 1px">
            <div></div>
            <button
                pButton
                pRipple
                type="button"
                label="View"
                class="p-button-text"
                [style]="{ width: '100%' }"
                icon="pi pi-eye"
                iconPos="right"
                (click)="_customerService.showNewEdit = true"
            ></button>
            
            <button
                pButton
                pRipple
                disabled
                type="button"
                label="Delete"
                [style]="{ width: '100%' }"
                class="p-button-danger p-button-text"
                icon="pi pi-trash"
                iconPos="right"
                (click)="optionDeleteClicked()"
            ></button>
        </div>
    </ng-template>
</p-overlayPanel>

<div class="fadeindown animation-duration-500 flex" *ngIf="1 == 1">
    <div class="conn-card customers-card" style="width: 100%; border-top-right-radius: 10px">
        <button
            pButton
            pRipple
            type="button"
            icon="pi pi-refresh"
            class="p-button-text p-button-rounded customers-refresh-btn"
            pTooltip="Refresh"
            tooltipPosition="top"
            [loading]="loadingCustomerList"
            (click)="getDataList()"
        ></button>
        <div class="p-2 mb-2">
            <app-report-top-filter-bar
                [paraReportName]="'Connect Customers'"
                [hideSearchControls]="true"
                (filterCallbackFunc)="callbackFuncFromFilter($event)"
                (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
                (exportExcelFn)="exportExcel()"
                (exportPdfFn)="exportPdf()"
                (exportCsvFn)="dt.exportCSV()"
                (deleteItemFn)="deleteMultiple()"
            ></app-report-top-filter-bar>
        </div>
        <div class="customers-summary px-2 mb-3">
            <div class="summary-tile tile-total">
                <span class="summary-icon"><i class="pi pi-users"></i></span>
                <div class="summary-text">
                    <span class="summary-label">Total</span>
                    <span class="summary-value">{{ loadingCustomerList ? '-' : summaryCounts.total }}</span>
                </div>
            </div>
            <div class="summary-tile tile-active">
                <span class="summary-icon"><i class="pi pi-check-circle"></i></span>
                <div class="summary-text">
                    <span class="summary-label">Active</span>
                    <span class="summary-value">{{ loadingCustomerList ? '-' : summaryCounts.active }}</span>
                </div>
            </div>
            <div class="summary-tile tile-inactive">
                <span class="summary-icon"><i class="pi pi-times-circle"></i></span>
                <div class="summary-text">
                    <span class="summary-label">Inactive</span>
                    <span class="summary-value">{{ loadingCustomerList ? '-' : summaryCounts.inactive }}</span>
                </div>
            </div>
        </div>
        <!-- <div class="flex justify-content-center align-items-center gap-3 mb-2 p-2">
            <div class="flex flex-column gap-1">
              
                <div class="flex justify-content-between gap-5">
                    <div class="flex amount-block">
                        <span class="ontrol-description text-xl text-muted">Current month sales revenues:</span>
                        <span class="control-description text-bold text-xl ml-2">{{dashboardSummaryObj?.currentSaleRevenue | currency : "USD" : "symbol"}}</span>
                    </div>
                    <div class="flex amount-block">
                        <span class="ontrol-description text-xl text-muted"
                            >Previous month sales revenues:</span
                        >
                        <span class="control-description text-bold text-xl ml-2">{{dashboardSummaryObj?.previousSaleRevenue | currency : "USD" : "symbol"}}</span>
                    </div>
                </div>
              
                <div class="flex justify-content-between gap-5">
                    <div class="flex amount-block">
                        <span class="ontrol-description text-xl text-muted"
                            >Current month sales tax collected:</span
                        >
                        <span class="control-description text-bold text-xl ml-2">{{dashboardSummaryObj?.currentSaleTaxCollected | currency : "USD" : "symbol"}}</span>
                    </div>
                    <div class="flex amount-block">
                        <span class="ontrol-description text-xl text-muted"
                            >Previous month sales tax collected:</span
                        >
                        <span class="control-description text-bold text-lg ml-2">{{dashboardSummaryObj?.previousSaleTaxCollected | currency : "USD" : "symbol"}}</span>
                    </div>
                </div>
            </div>
        </div> -->
        <p-table
            *ngIf="loadingCustomerList || dataList !== null"
            #dt
            [columns]="csvcols"
            styleClass="p-datatable-striped customers-table"
            [autoLayout]="true"
            [tableStyle]="{ width: 'max-content' }"
            [value]="loadingCustomerList ? skeletonRows : dataList"
            responsiveLayout="scroll"
            [showLoader]="false"
            rowHover="true"
            rowHover="true"
            dataKey="id"
            sortField="businessName"
            sortOrder="1"
            (onRowClick)="onRowClick($event)"
            [globalFilterFields]="['firstName', 'lastName', 'businessName','currentSubscription.startedDate','city','state']"
        >
            <!--    <ng-template pTemplate="caption">
            <div class="flex justify-content-between  ">
                <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                 <div class="flex">
                    <div class="p-float-label hide-1024" >
                        <input
                            type="text"
                            id="bob"
                            [(ngModel)]="searchText"
                            pInputText
                            [style]="{
                                'min-width': '200px',
                                'font-size': '85.rem'
                            }"
                        />
                        <label for="searchtext">Enter Name,Phone</label>
                    </div>
                    <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-search"
                    class="p-button-text"
                    (click)="searchTextSearch()"
                ></button>
                <button
                style="color: var(--brandColor)"
                pButton
                pRipple
                type="button"
                icon="pi pi-download"
                pTooltip="Export options"
                tooltipPosition="left"
                class="p-button-rounded p-button-text p-button-info"
                (click)="op.toggle($event)"
                [disabled]="disableAllControls"
            ></button>
            <p-overlayPanel #op class="exportpanel">
                <ng-template pTemplate>
                    <button
                        style="width: 100%; margin-bottom: 1rem"
                        type="button"
                        pButton
                        pRipple
                        icon="pi pi-file-excel"
                        (click)="exportExcel()"
                        pTooltip="XLS"
                        tooltipPosition="bottom"
                        label="Export to Excel"
                        class="p-button-outlined p-button-success"
                    ></button>

                    <button
                        style="width: 100%"
                        type="button"
                        pButton
                        pRipple
                        icon="pi pi-file-pdf"
                        (click)="exportPdf()"
                        pTooltip="PDF"
                        label="Export to PDF"
                        tooltipPosition="bottom"
                        class="p-button-outlined p-button-warning"
                    ></button>
                </ng-template>
            </p-overlayPanel>
                 </div>


                 <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>-->
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="businessName">
                        Business Name <p-sortIcon field="businessName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="cityLabel">
                        City <p-sortIcon field="cityLabel"></p-sortIcon>
                    </th>
                    <th pSortableColumn="stateLabel">
                        State <p-sortIcon field="stateLabel"></p-sortIcon>
                    </th>
                    <th pSortableColumn="contactLastName" style="white-space: nowrap">
                        Last Name <p-sortIcon field="contactLastName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="contactFirstName" style="white-space: nowrap">
                        First Name <p-sortIcon field="contactFirstName"></p-sortIcon>
                    </th>
                    <th style="white-space: nowrap">Phone</th>
                    <th pSortableColumn="contactEmailLabel" style="white-space: nowrap">
                        Email <p-sortIcon field="contactEmailLabel"></p-sortIcon>
                    </th>
                    <th pSortableColumn="statusLabel">
                        Status <p-sortIcon field="statusLabel"></p-sortIcon>
                    </th>
                    <th pSortableColumn="setupStatusLabel" style="white-space: nowrap">
                        Setup <p-sortIcon field="setupStatusLabel"></p-sortIcon>
                    </th>
                    <th pSortableColumn="planLabel">
                        Plan <p-sortIcon field="planLabel"></p-sortIcon>
                    </th>
                    <!-- <th>Contact Number</th>
                    <th>Contact Email</th> -->
                    <th pSortableColumn="currentSubscription.total" style="width: 120px; white-space: nowrap">
                        Sub Amount <p-sortIcon field="currentSubscription.total"></p-sortIcon>
                    </th>
                    <th style="white-space: nowrap">Last Payment</th>
                    <th pSortableColumn="paymentStatusLabel" style="white-space: nowrap">
                        Payment Status <p-sortIcon field="paymentStatusLabel"></p-sortIcon>
                    </th>
                    <!-- <th pSortableColumn="sales7D">
                        <p-sortIcon field="sales7D"></p-sortIcon>Sales 7D
                    </th>
                    <th pSortableColumn="sales30D">
                        <p-sortIcon field="sales30D"></p-sortIcon>Sales 30D
                    </th>
                    <th pSortableColumn="sales1Y">
                        <p-sortIcon field="sales1Y"></p-sortIcon>Sales 1Y
                    </th>
                    <th pSortableColumn="txn30D">
                        <p-sortIcon field="txn30D"></p-sortIcon>Txn 30D
                    </th> -->
                    <th pSortableColumn="currentSubscription.startedDate">
                        Created Date <p-sortIcon field="currentSubscription.startedDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="lastLoginTimestamp" style="white-space: nowrap">
                        Last Login Date <p-sortIcon field="lastLoginTimestamp"></p-sortIcon>
                    </th>
                    <th pSortableColumn="totalLoginCount" style="white-space: nowrap">
                        Total Login Count <p-sortIcon field="totalLoginCount"></p-sortIcon>
                    </th>
                    <!-- <th>24 hr sales</th>
                    <th>24 hr transactions</th>
                    <th>30 Day Sales</th>
                    <th>30 Day Transactions</th>
                    <th>12 month Sales</th>
                    <th>12 Month Transactions</th> -->
                </tr>
                <tr>
                    <th>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="businessNameFilter"
                            (input)="implementLocalFilter()"
                            [style]="{ width: '100%' }"
                        />
                    </th>
                    <th>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="cityFilter"
                            (input)="implementLocalFilter()"
                            [style]="{ width: '100%' }"
                        />
                    </th>
                    <th>
                        <p-dropdown
                            [options]="stateFilterOptions"
                            [(ngModel)]="selectedStateFilter"
                            optionLabel="label"
                            optionValue="value"
                            [showClear]="true"
                            [filter]="true"
                            appendTo="body"
                            (onChange)="applyDropdownFilter($event.value, 'stateLabel')"
                            placeholder="All"
                            [style]="{ width: '100%' }"
                        ></p-dropdown>
                    </th>
                    <th>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="lastNameFilter"
                            (input)="implementLocalFilter()"
                            [style]="{ width: '100%' }"
                        />
                    </th>
                    <th>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstNameFilter"
                            (input)="implementLocalFilter()"
                            [style]="{ width: '100%' }"
                        />
                    </th>
                    <th>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="phoneFilter"
                            (input)="implementLocalFilter()"
                            [style]="{ width: '100%' }"
                        />
                    </th>
                    <th>
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="emailFilter"
                            (input)="implementLocalFilter()"
                            [style]="{ width: '100%' }"
                        />
                    </th>
                    <th>
                        <p-dropdown
                            [options]="statusFilterOptions"
                            [(ngModel)]="selectedStatusFilter"
                            optionLabel="label"
                            optionValue="value"
                            [showClear]="true"
                            appendTo="body"
                            (onChange)="applyDropdownFilter($event.value, 'statusLabel')"
                            placeholder="All"
                            [style]="{ width: '100%' }"
                        ></p-dropdown>
                    </th>
                    <th></th>
                    <th>
                        <p-dropdown
                            [options]="planFilterOptions"
                            [(ngModel)]="selectedPlanFilter"
                            optionLabel="label"
                            optionValue="value"
                            [showClear]="true"
                            appendTo="body"
                            (onChange)="applyDropdownFilter($event.value, 'planLabel')"
                            placeholder="All"
                            [style]="{ width: '100%' }"
                        ></p-dropdown>
                    </th>
                    <th style="width: 120px">
                        <input
                            pInputText
                            type="text"
                            [(ngModel)]="subscriptionAmountFilter"
                            (input)="implementLocalFilter()"
                            [style]="{ width: '100%' }"
                        />
                    </th>
                    <th></th>
                    <th></th>
                    <!-- <th>
                        <p-columnFilter field="sales7D" matchMode="contains" [showMenu]="false" [showClearButton]="false"></p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="sales30D" matchMode="contains" [showMenu]="false" [showClearButton]="false"></p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="sales1Y" matchMode="contains" [showMenu]="false" [showClearButton]="false"></p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="txn30D" matchMode="contains" [showMenu]="false" [showClearButton]="false"></p-columnFilter>
                    </th> -->
                    <th>
                        <div class="created-date-filter" [ngClass]="'mode-' + createdDateFilterMode">
                            <p-dropdown
                                class="created-date-mode"
                                [options]="createdDateModeOptions"
                                [(ngModel)]="createdDateFilterMode"
                                optionLabel="label"
                                optionValue="value"
                                appendTo="body"
                                (onChange)="onCreatedDateModeChange()"
                                [style]="{ width: '100%' }"
                            ></p-dropdown>
                            <div class="created-date-input">
                                <p-calendar
                                    *ngIf="createdDateFilterMode === 'date'"
                                    [(ngModel)]="createdDateFilterDate"
                                    dateFormat="m/d/yy"
                                    appendTo="body"
                                    [showIcon]="true"
                                    [showButtonBar]="true"
                                    [readonlyInput]="true"
                                    [style]="{ width: '100%' }"
                                    placeholder="Select start date"
                                    (onSelect)="applyCreatedDateFilter()"
                                    (ngModelChange)="applyCreatedDateFilter()"
                                ></p-calendar>
                                <p-dropdown
                                    *ngIf="createdDateFilterMode === 'month'"
                                    [options]="createdMonthOptions"
                                    [(ngModel)]="createdDateFilterMonth"
                                    optionLabel="label"
                                    optionValue="value"
                                    [showClear]="true"
                                    appendTo="body"
                                    [style]="{ width: '100%' }"
                                    (onChange)="applyCreatedDateFilter()"
                                    (onClear)="applyCreatedDateFilter()"
                                    placeholder="All"
                                ></p-dropdown>
                                <p-dropdown
                                    *ngIf="createdDateFilterMode === 'year'"
                                    [options]="createdYearOptions"
                                    [(ngModel)]="createdDateFilterYear"
                                    optionLabel="label"
                                    optionValue="value"
                                    [showClear]="true"
                                    appendTo="body"
                                    [style]="{ width: '100%' }"
                                    (onChange)="applyCreatedDateFilter()"
                                    placeholder="Select year"
                                ></p-dropdown>
                                <p-calendar
                                    *ngIf="createdDateFilterMode === 'range'"
                                    selectionMode="range"
                                    [(ngModel)]="createdDateFilterRange"
                                    dateFormat="m/d/yy"
                                    appendTo="body"
                                    [showIcon]="true"
                                    [showButtonBar]="true"
                                    [readonlyInput]="true"
                                    [style]="{ width: '100%' }"
                                    placeholder="Select date range"
                                    (onSelect)="applyCreatedDateFilter()"
                                    (ngModelChange)="applyCreatedDateFilter()"
                                ></p-calendar>
                            </div>
                        </div>
                    </th>
                    <th class="last-login-col" style="width: 10rem; min-width: 10rem; max-width: 10rem">
                        <p-calendar
                            [(ngModel)]="lastLoginDateFilterRange"
                            selectionMode="range"
                            dateFormat="m/d/yy"
                            appendTo="body"
                            [showIcon]="false"
                            [showButtonBar]="true"
                            [readonlyInput]="true"
                            [style]="{ width: '100%' }"
                            placeholder="Select date range"
                            (onSelect)="applyLastLoginDateFilter()"
                            (ngModelChange)="applyLastLoginDateFilter()"
                        ></p-calendar>
                    </th>
                    <th></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr *ngIf="loadingCustomerList; else customerRow">
                    <td><p-skeleton width="11rem" height="1rem"></p-skeleton></td>
                    <td><p-skeleton width="5rem" height="1rem"></p-skeleton></td>
                    <td><p-skeleton width="5.5rem" height="1rem"></p-skeleton></td>
                    <td><p-skeleton width="5rem" height="1rem"></p-skeleton></td>
                    <td><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                    <td><p-skeleton width="7rem" height="1rem"></p-skeleton></td>
                    <td *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]"><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                    <td><p-skeleton width="8rem" height="1rem"></p-skeleton></td>
                    <td><p-skeleton width="3rem" height="1rem"></p-skeleton></td>
                </tr>
                <ng-template #customerRow>
                    <tr
                        (click)="onRowClick(item)"
                        [pSelectableRow]="item"
                        class="{{
                            item.selected == true ? 'p-highlight' : ''
                        }}"
                    >
                        <td>{{ item?.businessName }}</td>
                        <td>{{ item?.cityLabel || '-' }}</td>
                        <td>{{ item?.stateLabel || '-' }}</td>
                        <td>{{ item?.contactLastName || '-' }}</td>
                        <td>{{ item?.contactFirstName || '-' }}</td>
                        <td style="white-space: nowrap">{{ item?.contactPhoneLabel || '-' }}</td>
                        <td>{{ item?.contactEmailLabel || '-' }}</td>
                        <td>{{ item?.statusLabel }}</td>
                        <td>
                            <span *ngIf="item?.setupStatusLabel; else noSetup" class="setup-status"
                                [pTooltip]="getSetupTooltip(item)" tooltipPosition="top">
                                <span class="status-dot"
                                    [style.background]="getSetupStatusColor(item?.setupStatusLabel)"></span>
                            </span>
                            <ng-template #noSetup>-</ng-template>
                        </td>
                        <td>
                            {{ item?.planLabel }}
                            <i
                                *ngIf="item?.planChangedNote"
                                class="pi pi-arrow-circle-up plan-changed-icon"
                                [pTooltip]="item.planChangedNote"
                                tooltipPosition="top"
                            ></i>
                        </td>
                        <td>
                            <ng-container *ngIf="formatSubscriptionAmountPlain(item?.currentSubscription?.total) !== '-'; else emptyAmount">
                                ${{ formatSubscriptionAmountPlain(item?.currentSubscription?.total) }}
                            </ng-container>
                            <ng-template #emptyAmount>-</ng-template>
                        </td>
                        <td style="white-space: nowrap">{{ item?.lastPaymentLabel || '-' }}</td>
                        <td>
                            <span class="status-badge" *ngIf="item?.paymentStatusLabel"
                                [style.background]="getPaymentStatusColor(item?.paymentStatusLabel)">
                                {{ item?.paymentStatusLabel }}
                            </span>
                        </td>
                        <td>
                            {{item?.startedDate | date : "M/d/yyyy" }}
                        </td>
                        <td style="white-space: nowrap">{{ item?.lastLoginLabel }}</td>
                        <td style="text-align: center">{{ item?.totalLoginCount ?? '-' }}</td>
                    </tr>
                </ng-template>
            </ng-template>
        </p-table>
        <div class="flex" *ngIf="!loadingCustomerList && (baseDataList?.length == 0 || noData)">
            <div class="text-align-center" style="width: 100%">
                <span class="control-description text-muted text-align-center">
                    No data found!</span
                >
            </div>
        </div>
        <p-paginator
            #p
            *ngIf="totalRecords > 0"
            (onPageChange)="onPageChange($event)"
            [first]="page * rows"
            [rows]="rows"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="rowsPerPageOptions"
            [showCurrentPageReport]="!isMobileView"
            [pageLinkSize]="isMobileView ? 3 : 5"
            currentPageReportTemplate="Page: {currentPage} of {totalPages}, Total Records: {totalRecords}"
        ></p-paginator>

        <!-- <app-paginator
            #paginator
            (paginatorCallbackFn)="onPage($event)"
            [page]="page"
            [totalRecords]="totalRecords"
        ></app-paginator> -->
    </div>
</div>

<!-- <p-dialog
    *ngIf="_customerService.showNewEdit"
    header="Edit Customer "
    [(visible)]="_customerService.showNewEdit"
    [style]="{ width: '60%' }"
    modal="true"
>
    <app-customer-info-change
        (refreshDataEmitter)="getDataList()"
    ></app-customer-info-change>
</p-dialog> -->
